import CoreInstance from '../CoreInstance';
import { CORE_WEBHOOKS_URL } from '../../config';
// import { setParam } from 'api/client/ClientInstance';

interface IcommonEndpoints {
  getProcessFilesToS3(fileName: string): any;
  postProcessFilesToS3(fileName: string, mimeType: string): any;
}

const commonEndpoints: IcommonEndpoints = {
  getProcessFilesToS3: (fileName: string) => CoreInstance.get(
    `/kinedu_processes/s3_files/create_record?file_name=${fileName}`,
    { baseURL: CORE_WEBHOOKS_URL }
  ),
  postProcessFilesToS3: (fileName: string, mimeType: string) => CoreInstance.post(
    '/kinedu_processes/s3_files/create_record',
    { s3_file: { file_name: fileName, mime_type: mimeType } },
    { baseURL: CORE_WEBHOOKS_URL },
  ),
};

export default commonEndpoints;
